import { render, staticRenderFns } from "./KardexPagosUpiBolivia.vue?vue&type=template&id=5651a44e"
import script from "./KardexPagosUpiBolivia.vue?vue&type=script&lang=js"
export * from "./KardexPagosUpiBolivia.vue?vue&type=script&lang=js"
import style0 from "./KardexPagosUpiBolivia.vue?vue&type=style&index=0&id=5651a44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports